import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { ModalSize, SuiModalService } from "@richardlt/ng2-semantic-ui";
import { Router } from "@angular/router";
import { ViewDetailsModal } from "src/modules/features/contractor/modals";
import { ConfirmModal } from "src/modules/shared";
import { EwalletService } from "src/modules/features/admin/services/ewallet";
@Component({
	selector: "app-bank-change-request-row",
	templateUrl: "./bank-change-request-row.component.html",
	styleUrls: ["./bank-change-request-row.component.scss"],
})
export class BankChangeRequestRowComponent implements OnInit {
	@Input() request: any;
	@Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onClickChat: EventEmitter<any> = new EventEmitter();


	constructor(
		private modalService: SuiModalService,
		private router: Router,
		private walletSvc: EwalletService
	) {}

	dataToJSON(data: any) {
		return JSON.parse(data);
	}

	viewDetails() {
		this.modalService.open(
			new ViewDetailsModal("View Change of Bank Details Request", this.request)
		);
	}

	cancelRequest(request) {
		this.onCancel.emit(request);
	}

	chatWithNCC(request) {
    this.onClickChat.emit(request);
	}

	ngOnInit(): void {}
}
